@if (errorKeys.length) {
  <div class="alert alert-danger">
    @for (key of errorKeys; track key) {
      <div>{{ key | translate }}</div>
    }
  </div>
}

@switch (stage) {

  @case ('choose') {
    <h2 class="auth-title">{{ 'AUTH.MFA_SETUP_TITLE' | translate }}</h2>
    <p class="auth-lede">{{ 'AUTH.MFA_SETUP_LEDE' | translate }}</p>

    @if (allows('totp')) {
      <button type="button" class="auth-method" [disabled]="busy" (click)="begin('totp')">
        <strong>{{ 'AUTH.MFA_METHOD_TOTP' | translate }}</strong>
        <span>{{ 'AUTH.MFA_METHOD_TOTP_HINT' | translate }}</span>
      </button>
    }
    @if (allows('email')) {
      <button type="button" class="auth-method" [disabled]="busy" (click)="begin('email')">
        <strong>{{ 'AUTH.MFA_METHOD_EMAIL' | translate }}</strong>
        <span>{{ 'AUTH.MFA_METHOD_EMAIL_HINT' | translate }}</span>
      </button>
    }
  }

  @case ('totp') {
    <h2 class="auth-title">{{ 'AUTH.MFA_TOTP_TITLE' | translate }}</h2>
    <p class="auth-lede">{{ 'AUTH.MFA_TOTP_LEDE' | translate }}</p>

    @if (qrDataUrl) {
      <img class="auth-qr" [src]="qrDataUrl" alt="{{ 'AUTH.MFA_TOTP_QR_ALT' | translate }}">
    }
    @if (secret) {
      <code class="auth-secret">{{ secret }}</code>
      <p class="auth-note">{{ 'AUTH.MFA_TOTP_SECRET_HINT' | translate }}</p>
    }

    <form (ngSubmit)="confirm()" #totpForm="ngForm">
      <div class="form-group">
        <label for="totpCode">{{ 'AUTH.MFA_CODE' | translate }}</label>
        <input type="text" class="form-control auth-code-input" id="totpCode" name="totpCode"
               [(ngModel)]="code" inputmode="numeric" autocomplete="one-time-code"
               maxlength="6" required #totpCode="ngModel">
      </div>
      <div class="auth-actions">
        <button type="button" class="btn btn-outline-secondary" [disabled]="busy" (click)="back()">
          {{ 'FUNCTION-BUTTONS.CANCEL' | translate }}
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="busy || !totpForm.form.valid">
          {{ 'AUTH.MFA_CONFIRM' | translate }}
        </button>
      </div>
    </form>
  }

  @case ('email') {
    <h2 class="auth-title">{{ 'AUTH.MFA_EMAIL_TITLE' | translate }}</h2>
    <p class="auth-lede">{{ 'AUTH.MFA_EMAIL_LEDE' | translate }}</p>

    <form (ngSubmit)="confirm()" #emailForm="ngForm">
      <div class="form-group">
        <label for="emailCode">{{ 'AUTH.MFA_CODE' | translate }}</label>
        <input type="text" class="form-control auth-code-input" id="emailCode" name="emailCode"
               [(ngModel)]="code" inputmode="numeric" autocomplete="one-time-code"
               maxlength="6" required #emailCode="ngModel">
      </div>
      <div class="auth-actions">
        <button type="button" class="btn btn-outline-secondary" [disabled]="busy" (click)="back()">
          {{ 'FUNCTION-BUTTONS.CANCEL' | translate }}
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="busy || !emailForm.form.valid">
          {{ 'AUTH.MFA_CONFIRM' | translate }}
        </button>
      </div>
    </form>
  }

  @case ('codes') {
    <h2 class="auth-title">{{ 'AUTH.RECOVERY_TITLE' | translate }}</h2>
    <div class="auth-warning">{{ 'AUTH.RECOVERY_WARNING' | translate }}</div>

    <div class="auth-recovery">
      @for (rc of recoveryCodes; track rc) {
        <span>{{ rc }}</span>
      }
    </div>

    <div class="auth-actions">
      <button type="button" class="btn btn-outline-secondary" (click)="downloadCodes()">
        {{ 'AUTH.RECOVERY_DOWNLOAD' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="acknowledge()">
        {{ 'AUTH.RECOVERY_ACKNOWLEDGE' | translate }}
      </button>
    </div>
  }
}
